import { HttpRequest } from '@angular/common/http';

import * as actions from './file-upload.actions';
import { FileRecordDto } from '@careapp-group/ng-sdk';
import { createReducer, on } from '@ngrx/store';

export interface State {
  [id: string]: {
    file: File;
    url: string;
    progress: number;
    cancelled: boolean;
    error?: string;
    success?: boolean;
    request?: HttpRequest<any>;
    response?: FileRecordDto;
  };
}

export const initialState: State = {};

export const fileUploadReducer = createReducer(
  initialState,
  on(actions.RequestFileUploadStartAction, (state, { id, file, url }) => {
    return {
      ...state,
      [id]: {
        file,
        url,
        progress: 0,
        cancelled: false,
      },
    };
  }),
  on(actions.RequestFileUploadCancelAction, (state, { id }) => ({
    ...state,
    [id]: { ...state[id], cancelled: true },
  })),
  on(actions.ResponseFileUploadProgressAction, (state, { id, progress }) => ({
    ...state,
    [id]: {
      ...state[id],
      progress: progress,
    },
  })),
  on(actions.ResponseFileUploadCompleteAction, (state, { id, response }) => ({
    ...state,
    [id]: {
      ...state[id],
      response: response,
      progress: 100,
      success: true,
    },
  })),
  on(actions.ResponseFileUploadErrorAction, (state, { id, error }) => ({
    ...state,
    [id]: {
      ...state[id],
      error,
    },
  })),
  on(actions.RequestFileUploadRetryAction, (state, { id }) => ({
    ...state,
    [id]: {
      ...state[id],
      error: null,
      progress: 0,
      success: false,
    },
  })),
);
